import React, { useEffect, useRef } from "react";
import useDimensions from "react-cool-dimensions";
import { ResizeObserver } from "@juggle/resize-observer";
import animationStyles from "../../style/animation.module.css";

/**
 * SlideAnimationFrame - Manages animated slide transitions
 * 
 * Uses truncated animation (starts at 60% of motion).
 * All slides share one parent container (the Card in wrapper.jsx).
 */

var SlideAnimationFrame = function(props) {
  var sections = props.sections;
  var activeSectionIndex = props.activeSectionIndex;
  var parentRef = useRef(null);

  var updateActiveFrameDimensions = function(ref) {
    if (!ref) return;
    var activeSection = document.querySelector("." + (sections[activeSectionIndex]?.id || ""));
    if (activeSection) {
      ref.style.height = activeSection.scrollHeight + "px";
    }
  };

  var { observe } = useDimensions({
    useBorderBoxSize: true,
    polyfill: ResizeObserver,
    onResize: function(data) {
      updateActiveFrameDimensions(data.entry.target);
    },
  });

  var getClassName = function(index) {
    if (index === sections.length - 1) {
      if (activeSectionIndex === index) {
        return animationStyles.infoCnt + " " + animationStyles.animationBaseSlide + " " + (sections[index]?.id || "");
      }
      return animationStyles.infoCnt + " " + animationStyles.infoCntNotActive + " " + animationStyles.animationBaseSlide + " " + animationStyles.animationSlideFade + " " + (sections[index]?.id || "");
    } else {
      if (activeSectionIndex === index) {
        return animationStyles.infoCnt + " " + animationStyles.animationBaseSlide + " " + (sections[index]?.id || "");
      }
      if (activeSectionIndex === index + 1) {
        return animationStyles.infoCnt + " " + animationStyles.infoCntNotActive + " " + animationStyles.animationBaseZoom + " " + animationStyles.animationZoomFade + " " + (sections[index]?.id || "");
      }
      return animationStyles.infoCnt + " " + animationStyles.infoCntNotActive + " " + animationStyles.animationBaseSlide + " " + animationStyles.animationSlideFade + " " + (sections[index]?.id || "");
    }
  };

  useEffect(function() {
    updateActiveFrameDimensions(parentRef.current);
  }, [activeSectionIndex]);

  return (
    <div
      className={animationStyles.animationContainer}
      ref={function(el) {
        observe(el);
        parentRef.current = el;
      }}
    >
      {sections?.map(function(section, index) {
        return (
          <div
            className={getClassName(index)}
            key={"animation_frame_" + (section.id || index)}
          >
            {section.children}
          </div>
        );
      })}
    </div>
  );
};

export default SlideAnimationFrame;
